<template>
	<ul class="list-unstyled text-left py-md-4 h-100">
		<li v-for="p in pages" :key="p.rank" :class="{ l1: p.level == 1, 'ml-3': p.level == 2, 'ml-5': p.level == 3 }">
			<div v-if="p.menu_item">
				<router-link v-if="p.path != ''" :to="p.path">{{ p.title }}</router-link>
				<div v-else>{{ p.title }}</div>
			</div>
		</li>
	</ul>
</template>

<script>
export default {
	data() {
		return {};
	},
	props: {
		pages: {
			type: Array,
			function() {
				return [];
			},
		},
	},
};
</script>

<style scoped>
.l1 {
	margin-top: 0.2rem;
	text-transform: uppercase;
}

ul {
	padding-left: 1rem;
}
ul ul {
	padding-left: 2rem;
}

li {
	list-style-type: none;
}

@media only screen and (max-width: 350px) {
	/* li a {
		font-size: 13px;
	} */
	.l1 {
		margin-top: 0.5rem;
	}
}
</style>